var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ScheduleBSettings", attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        [
          _c(
            "v-btn",
            {
              attrs: { disabled: _vm.getDataLoading, color: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleScheduleB(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("addCommonCommodity")) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.isMod
            ? [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.cancelEdit }
                  },
                  [_vm._v(_vm._s(_vm.$t("cancel")) + " ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { loading: _vm.saveLoading, color: "primary" },
                    on: { click: _vm.submit }
                  },
                  [_vm._v(_vm._s(_vm.$t("save")) + "\n      ")]
                )
              ]
            : _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled:
                      !_vm.commonCommodities.length || _vm.getDataLoading
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleScheduleB(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("editCommonCommodity")) + "\n    ")]
              ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "", xs4: "" } },
            [
              _c("v-select", {
                staticStyle: { paddingTop: "0" },
                attrs: {
                  items: _vm.commonCommodities,
                  label: _vm.$t("commonCommodityFilter"),
                  "item-text": "description",
                  "item-value": "description",
                  clearable: ""
                },
                model: {
                  value: _vm.commonCommodityFilter,
                  callback: function($$v) {
                    _vm.commonCommodityFilter = $$v
                  },
                  expression: "commonCommodityFilter"
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-form",
        { ref: "form" },
        [
          _c("v-data-table", {
            attrs: { headers: _vm.headers, items: _vm.tableData },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.isMod
                          ? [_vm._v(_vm._s(props.item.description))]
                          : _c("v-text-field", {
                              attrs: {
                                clearable: "",
                                label: _vm.$t("description"),
                                rules: [_vm.validDesc(props.index)],
                                required: ""
                              },
                              model: {
                                value: props.item.description,
                                callback: function($$v) {
                                  _vm.$set(
                                    props.item,
                                    "description",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "props.item.description"
                              }
                            })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.isMod
                          ? [_vm._v(_vm._s(props.item.code))]
                          : _c("v-text-field", {
                              attrs: {
                                clearable: "",
                                label: _vm.$t("code"),
                                rules: [_vm.fieldIsRequired()],
                                required: ""
                              },
                              model: {
                                value: props.item.code,
                                callback: function($$v) {
                                  _vm.$set(
                                    props.item,
                                    "code",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "props.item.code"
                              }
                            })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left" },
                      [
                        !_vm.isMod
                          ? [_vm._v(_vm._s(props.item.hsCode))]
                          : _c("v-text-field", {
                              attrs: {
                                clearable: "",
                                label: _vm.$t("hsCode"),
                                rules: [_vm.fieldIsRequired()],
                                required: ""
                              },
                              model: {
                                value: props.item.hsCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    props.item,
                                    "hsCode",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "props.item.hsCode"
                              }
                            })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.isMod
                      ? _c(
                          "td",
                          { staticClass: "text-xs-left" },
                          [
                            _c(
                              "v-layout",
                              { attrs: { "justify-center": "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      flat: "",
                                      icon: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteScheduleB(props.index)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "lighten-2" } },
                                      [_vm._v("delete")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f4f0976", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f4f0976","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonCommoditySettings.vue
// module id = null
// module chunks = 